import {
  type GQLInteractionQueryInput,
  GQLInteractionType,
  GQLOfferExperience,
} from '@/generated/graph-api';
import { useInteractionQuery } from '../interactions.generated';

export function useOfferExperience({ id, type }: GQLInteractionQueryInput) {
  const { data, loading, error } = useInteractionQuery({
    variables: {
      input: {
        id,
        type,
      },
    },
    skip: type !== GQLInteractionType.listing,
  });
  const offerExperience =
    (data?.interaction &&
      'offerExperience' in data.interaction &&
      data.interaction.offerExperience) ||
    undefined;

  return {
    offerExperience,
    isLOMOfferExperience: offerExperience === GQLOfferExperience.lom,
    loading,
    error,
  } as const;
}
